import React, { useState } from "react";
import {
  GoogleAuthProvider,
  OAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
  deleteUser,
  signOut,
} from "firebase/auth";
import { auth } from "../firebaseConfig";
import { useNavigate } from "react-router-dom";
import { isExistAccount } from "../utils/api";
import "./Login.css";

const handleFailedLogin = async (authInstance) => {
  try {
    const user = authInstance.currentUser;
    console.log("handleFailedLogin user : ", user);
    if (user) {
      await deleteUser(user);
      console.log("[존재X 계정!] Firebase 사용자 삭제 완료");
    }
  } catch (err) {
    console.error("[존재X 계정!] Firebase 사용자 삭제 실패 ", err.message);
  }
  // 바로 탈퇴 후 signOut 처리
  try {
    await signOut(authInstance);
    console.log("[존재X 계정!] Firebase 세션 로그아웃 완료");
  } catch (err) {
    console.error("[존재X 계정!] Firebase 세션 로그아웃 실패 ", err.message);
  }

  alert("존재하지 않는 계정입니다. 다시 확인해주세요!");
};

const checkAccount = async (inputEmail) => {
  if (!inputEmail) {
    console.warn("이메일이 없습니다. ");
    return false;
  }

  try {
    const result = await isExistAccount(inputEmail);
    console.log("return data : ", result);
    return result;
  } catch (error) {
    console.error("계정 확인 중 오류 발생:", error);
    return false;
  }
};

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // 이메일/비밀번호 로그인
  const handleLogin = async () => {
    if (!email || !password) {
      return alert("이메일과 비밀번호를 입력해주세요!");
    }

    setLoading(true);
    const isExists = await checkAccount(email);
    if (!isExists) {
      setLoading(false);
      setEmail("");
      setPassword("");
      return alert("존재하지 않는 계정입니다. 다시 확인해주세요!");
    }

    try {
      await signInWithEmailAndPassword(auth, email, password);
      console.log("이메일 로그인 성공 ~!! 🥳");
      navigate("dashboard", { replace: true });
    } catch (error) {
      alert("이메일 로그인을 실패하였습니다.");
      console.log("이메일 로그인 실패 ", error);
    } finally {
      setLoading(false);
    }
  };

  // Google 로그인
  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const res = await signInWithPopup(auth, provider);
      setLoading(true);
      const googleEmail = res.user?.email;
      console.log("google res ", res);
      console.log("google googleEmail ", googleEmail);
      const isExists = await checkAccount(googleEmail);
      if (!isExists) {
        await handleFailedLogin(auth);
        return;
      }

      console.log("Google 로그인 성공");
      navigate("dashboard", { replace: true });
    } catch (error) {
      if (
        error.code === "auth/popup-closed-by-user" ||
        "auth/cancelled-popup-request"
      ) {
        console.warn("사용자가 팝업을 닫았습니다.");
      } else {
        console.error("Google 로그인 실패", error);
        alert("Google 로그인을 실패하였습니다.");
      }
    } finally {
      setLoading(false);
    }
  };

  // Apple 로그인
  const handleAppleLogin = async () => {
    const provider = new OAuthProvider("apple.com");
    provider.addScope("email");
    provider.addScope("name");

    try {
      const result = await signInWithPopup(auth, provider);
      const appleEmail = result.user?.email;
      setLoading(true);
      const isExists = await checkAccount(appleEmail);
      if (!isExists) {
        await handleFailedLogin(auth);
        return;
      }

      console.log("Apple 로그인 성공 ~!! 🥳");
      navigate("dashboard", { replace: true });
    } catch (error) {
      if (
        error.code === "auth/popup-closed-by-user" ||
        "auth/cancelled-popup-request"
      ) {
        console.warn("사용자가 팝업을 닫았습니다.");
      } else {
        console.error("Firebase Apple 로그인 실패:", error);
        alert("Apple 로그인을 실패하였습니다.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      {loading && (
        <div className="spinner-overlay">
          <div className="spinner"></div>
        </div>
      )}
      <h1 className="title">Kiwe Delete Account Web</h1>

      <input
        type="email"
        placeholder="이메일"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="input"
      />

      <input
        type="password"
        placeholder="비밀번호"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="input"
      />
      <button
        onClick={handleLogin}
        className={`button-common button-email ${
          loading ? "button-disabled" : ""
        }`}
        disabled={loading}
      >
        이메일 로그인
      </button>

      <button
        onClick={handleGoogleLogin}
        className={`button-common button-google ${
          loading ? "button-disabled" : ""
        }`}
        disabled={loading}
      >
        Google 로그인
      </button>

      <button
        onClick={handleAppleLogin}
        className={`button-common button-apple ${
          loading ? "button-disabled" : ""
        }`}
        disabled={loading}
      >
        Apple 로그인
      </button>
    </div>
  );
}
export default Login;
